"use client";
import { useAppSelector } from "@/data/redux/store";

export function useAuthentication() {
  const authState = useAppSelector((state) => state.app.auth);

  return {
    isAuth: authState.loggedIn,
    ...authState
  };
}
